<template>
  <div class="app-information">
    <TopBarBackText title="정보" />

    <div class="mt-default px-16">
      <div v-if="!isApp" class="info w-full flex flex-space-between mb-16">
        <span class="label">웹 버전 정보</span>
        <span class="version">V {{ webVersion }}</span>
      </div>
      <div v-else class="info w-full flex flex-space-between mb-16">
        <span class="label">앱 버전 정보</span>
        <span class="version">V {{ appVersion }}</span>
      </div>
      <Separator />

      <div class="inc"> Gadget Korea INC.</div>
    </div>
  </div>
</template>

<script setup lang="ts">

const runtimeConfig = useRuntimeConfig()
const { isApp, appVersion, userAgent } = useAppCheck()

const webVersion = runtimeConfig.public.serviceVersion.replaceAll('"', '')


</script>

<style scoped lang="scss">
.app-information {
  padding-top: 54px;
  .info {
    color: $gray-600;
    .label {
      @include body4-medium;
    }
    .version {
      @include footnote1-semibold;
    }
  }
  .inc {
    margin: 16px 0;
    @include  body6-medium;
    color: $gray-400;
  }
}
</style>